import { format, parseISO } from "date-fns";
import type { RequestedPicturesPlotAllMattersData } from "../../types";

/**
 * 登記取得日をフォーマットする関数
 * @param time 登記取得日
 * @returns フォーマットされた日付
 */
export const formatUpdateTime = (time: string | null): string => {
  if (!time) {
    return "-";
  }
  try {
    const date = parseISO(time);
    return format(date, "yyyy年MM月dd日");
  } catch (e) {
    return time;
  }
};

/**
 * 登記取得日の配列から表示文言を生成する関数
 * @param allMatters 全部事項データ
 * @returns 表示文言
 */
export const getPictureUpdateTime = (
  allMatters: RequestedPicturesPlotAllMattersData
): string => {
  const time = allMatters.pictureUpdateTime;
  if (!time) {
    return "-";
  }
  return formatUpdateTime(time);
};
